<i18n src="@/locales/modules/RequestTypeTranslate.json"></i18n>

<template>
	<CbsContextMenu
		v-bind="$attrs"
		type="vertical"
		class="request-type-context-menu"
		:menuListDataBinding="{ class: 'request-type-context-menu-list' }"
	>
		<div v-if="requestType.can_update" class="request-type-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', requestType)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>

		<div v-if="requestType.can_update" class="request-type-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickSetting', requestType)">
			<i class="nucleo mr-3 nucleo-settings-gear" />
			{{ $t("Settings") }}
		</div>

		<div v-if="requestType.can_delete" class="request-type-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDelete', requestType.id)">
			<i class="nucleo mr-3 nucleo-trash-can" />
			{{ $t("Actions.Delete") }}
		</div>

		<div
			v-if="requestType.can_update"
			class="request-type-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickToggleStatus', requestType)"
		>
			<i 
				:class="[
					'nucleo mr-3',
					{
						'nucleo-padlock': !requestType.disable,
						'nucleo-cmunlock-outline': requestType.disable
					}
				]" 
			/>
			{{ $t(requestType.disable ? "EnableRequestType" : "DisableRequestType") }}
		</div>
	</CbsContextMenu>
</template>

<script>
import { requestTypePermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "RequestTypeContextMenu",
	mixins: [getUserPermissions(requestTypePermissions)],
	components: { CbsContextMenu },
	props: {
		requestType: {
			type: Object,
			required: true
		}
	},
	emits: {
		onClickEdit: {},
		onClickDelete: {},
		onClickSetting: {},
		onClickToggleStatus: {}
	}
};
</script>

<style lang="scss" scoped>
.request-type-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.request-type-context-menu-list {
	.request-type-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
